module.exports = __webpack_public_path__ + "static/img/dy.a4da4eb6.png";